
  document.addEventListener('DOMContentLoaded', function() {
    const accordion_rows = document.querySelectorAll('.ext-travel-accordion accordion-custom');
    const triggers = document.querySelectorAll('.ext-travel-accordion accordion-custom .ext-link');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const triggerId = this.getAttribute('data-link');
        const scrollTarget = document.getElementById(triggerId);
        const triggerContent = scrollTarget.closest('.details');
        console.log(triggerContent);
        setTimeout(function () {
           scrollTarget.scrollIntoView({
               behavior: "smooth",
               block: "start",
           });
        }, 100);
        triggerContent.open = true;

      });
    });
    accordion_rows.forEach(accordion_row => {
       accordion_row.addEventListener('click', function(e) {
        console.log('click');
        accordion_rows.forEach(accordion_row => {
          e.preventDefault();
          e.stopImmediatePropagation();
          accordion_row.querySelector('.details').open = false;
        });
        this.querySelector('.details').open = true;
        handleAccordionImage(this.getAttribute('data-class'));
         });
      });
  });

  handleAccordionImage = (imageClass) => {
    const accordionImage = document.getElementById('ext-travel-accordion-img');
    let imageSrc = 'https://cdn.shopify.com/s/files/1/0076/8983/0457/files/travel-center-air.jpg';
    switch (imageClass) {
      case "wayb-road":
        imageSrc = 'https://cdn.shopify.com/s/files/1/0076/8983/0457/files/travel-center-road.jpg';
        break;
      case "wayb-rideshares":
        imageSrc = 'https://cdn.shopify.com/s/files/1/0076/8983/0457/files/travel-center-rideshares.jpg';
        break;
      case "wayb-caregiver":
        imageSrc = 'https://cdn.shopify.com/s/files/1/0076/8983/0457/files/travel-center-caregiver.jpg';
        break
      default:
    }

    accordionImage.src = imageSrc;
  }

